// LanguageSelector.js - Versão COMPLETA e Integrada com i18n
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // Importamos o Hook para acessar o i18n
import '../styles/LanguageSelector.css';

const LanguageSelector = ({ isCollapsed }) => {
  // 1. Acessa a instância do i18n
  const { i18n } = useTranslation();

  // 2. Define o idioma inicial como o idioma atual do i18n
  // Isso garante que, ao carregar, a bandeira correta seja exibida
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Lista de idiomas suportados
  const languages = [
    {
      code: 'pt',
      flagPath: '/img/bandeiradobrasil-2-cke.webp',
      name: 'PT',
      shortName: 'PT',
    },
    {
      code: 'en',
      flagPath: '/img/EUA.jpg',
      name: 'EN',
      shortName: 'EN',
    },

    {
      code: 'es',
      flagPath: '/img/Flag_of_Spain.svg',
      name: 'ES',
      shortName: 'ES',
    },
  ];

  const currentLanguage = languages.find(
    lang => lang.code === selectedLanguage,
  );

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = event => {
      if (isDropdownOpen && !event.target.closest('.language-selector')) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isDropdownOpen]);

  // Função central para mudança de idioma
  const handleLanguageChange = langCode => {
    i18n.changeLanguage(langCode);

    setSelectedLanguage(langCode);

    setIsDropdownOpen(false);

    localStorage.setItem('selectedLanguage', langCode);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    setSelectedLanguage(i18n.language);
  }, [i18n.language]);

  return (
    <div className="language-selector">
      <button
        className='language-toggle'
        onClick={toggleDropdown}
        aria-label='Selecionar idioma'
        aria-expanded={isDropdownOpen}
      >
        <span className='flag-icon-span'>
          <img
            src={currentLanguage.flagPath}
            alt={`Bandeira ${currentLanguage.name}`}
            className='flag-svg'
          />
        </span>
        {!isCollapsed && (
          <span className='language-label'>{currentLanguage.shortName}</span>
        )}
        {!isCollapsed && (
          <svg
            className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`}
            viewBox='0 0 24 24'
            fill='currentColor'
            width='16'
            height='16'
          >
            <path d='M7 10l5 5 5-5z' />
          </svg>
        )}
      </button>

      {isDropdownOpen && (
        <div className='language-dropdown'>
          {languages.map(language => (
            <button
              key={language.code}
              className={`language-option ${
                selectedLanguage === language.code ? 'active' : ''
              }`}
              onClick={() => handleLanguageChange(language.code)}
            >
              <span className='flag-icon-span'>
                <img
                  src={language.flagPath}
                  alt={`Bandeira ${language.name}`}
                  className={`flag-svg ${
                    selectedLanguage === language.code ? '' : 'flag-inactive'
                  }`}
                />
              </span>
              {!isCollapsed && (
                <span className='language-name'>{language.name}</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
